
export enum EventSourceCd {
	AUTO_GENNED = 'Auto-genned',
	EDI = 'EDI',
	FTP = 'FTP',
	INTERNAL = 'Internal',
	WEB = 'Web'}

